import React from 'react'

const OverLay = () => (
  <div
    style={{
      position: 'fixed',
      width: '100vw',
      height: '100vh',
      top: 0,
      left: 0,
    }}
  />
)

OverLay.defaultProps = {}

OverLay.propTypes = {}
export default OverLay
